import { fromTo } from '@stores/billing';
import moment from 'moment';

//  returns the rolling dates in ms
//  valid strings are ISO string formats
//  number is epoch (ms)

const getRollingDates = (startDate: number | string | Date): fromTo => {
  const currentMonth = moment().month();
  const currentYear = moment().year();
  const currentDate = moment.utc().date();
  const startDateInMonth: number = moment.utc(startDate).date();
  let billingStartDate;
  if (currentDate < startDateInMonth) {
    billingStartDate = moment(startDate)
      .set('y', currentYear)
      .set('M', currentMonth - 1)
      .valueOf();
  } else {
    billingStartDate = moment(startDate).set('y', currentYear).set('M', currentMonth).valueOf();
  }
  const billingEndDate = moment(billingStartDate).add(1, 'M').valueOf();
  return {
    startDate: billingStartDate,
    endDate: billingEndDate,
  };
};

export default getRollingDates;
